import { render, staticRenderFns } from "./lkuArsetUnearn.vue?vue&type=template&id=1222c480"
import script from "./lkuArsetUnearn.vue?vue&type=script&lang=js"
export * from "./lkuArsetUnearn.vue?vue&type=script&lang=js"
import style0 from "./lkuArsetUnearn.vue?vue&type=style&index=0&id=1222c480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports